import {Model} from './model';

export class PenaltyInterestMethod implements Model {
  penaltyInterestMethodId: number;
  name: string;
  description: string;

  static copy(oldObj: PenaltyInterestMethod): PenaltyInterestMethod {
    const newObj = new PenaltyInterestMethod();
    newObj.penaltyInterestMethodId = oldObj.penaltyInterestMethodId;
    newObj.name = oldObj.name;
    newObj.description = oldObj.description;
    return newObj;
  }

  public getPrimaryKey(): number {
    return this.penaltyInterestMethodId;
  }

  isNew(): boolean {
    return isNaN(this.penaltyInterestMethodId);
  }

  clone(): PenaltyInterestMethod {
    return PenaltyInterestMethod.copy(this);
  }
}
